import React, {useState, useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {paths} from '../../../common/dictionaries/urls';
import {Actions} from '../../../common/actions';
import CanceledOrdersList from './canceledOrdersTable';
import Header from './header';
import Detail from './detail';
import './orders.scss';

const {
  fetchOrderAndTasksStatus,
  navigateTo,
  restoreDevicesOrdersPage,
} = Actions;

const PANES_INDICES = {
  'CREATE_ORDERS': 0,
  'CANCELED_ORDERS': 1,
};

const Index = () => {
  const [activeTabIndex, setActiveTabIndex] = useState(0);
  const [selectedFilters, setSelectedFilters] = useState({
    'date': '',
    'dateEnd': '',
    'chassis': '',
    'status': '',
    'invoiceType': 'N',
  });
  const permissions = useSelector((state) => state.session.permissions);
  const devicesOrders = useSelector((state) => state.devicesOrders);
  const accessoriesOrders = useSelector((state) => state.accessoriesOrders);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!hasAccessPermission(permissions, resources.DevicesOrders, scopes.See) &&
      !hasAccessPermission(permissions, resources.DevicesOrders, scopes.Edit)) {
      dispatch(navigateTo(paths.AccessDenied));
    }
    dispatch(restoreDevicesOrdersPage());
    dispatch(fetchOrderAndTasksStatus({'type': 'order'}));
  }, [dispatch]);

  const onChangeTab = (activeIndex) => {
    setActiveTabIndex(activeIndex);
  };

  const setSelectedFiltersState = (date, dateEnd, chassis, status, invoiceType) => {
    setSelectedFilters({
      'date': date,
      'dateEnd': dateEnd,
      'chassis': chassis,
      'status': status === 'ALL' ? '' : status,
      'invoiceType': invoiceType,
    });
  };

  const getPanesContent = () => {
    const panes = {
      [PANES_INDICES.CREATE_ORDERS]:
        <Detail
          devicesOrders={devicesOrders}
          orderStatusList={accessoriesOrders ? accessoriesOrders.orderStatusList : []}
          filtersState={selectedFilters} />,
      [PANES_INDICES.CANCELED_ORDERS]: <CanceledOrdersList devicesOrders={devicesOrders} />,
    };
    return panes[activeTabIndex];
  };

  return (
    <div className='devices-orders'>
      <Header
        activeTabIndex={activeTabIndex}
        changeTab={onChangeTab}
        devicesOrders={devicesOrders}
        orderStatusList={accessoriesOrders ? accessoriesOrders.orderStatusList : []}
        changeSelectedFiltersState={setSelectedFiltersState.bind(this)}
      />
      {getPanesContent()}
    </div>
  );
};

export default Index;
